import React from "react";
import Portfolio from "../../Portfolio";

const Darpan = () => {
  const portfolioImage = [
    // {
    //   img: "assets/img/m-samaj/samajDarpan1.png",
    //   title: "Samaj Darpan 1.0",
    //   link: "/darpan-view/1.0",
    //   description:
    //     "Samaj-Darpan 1.0 is the inaugural edition of our annual magazine, published by Mallabhum Prayas on August 30, 2019. This edition encapsulates the journey of our organization over the past year, highlighting our commitment to societal development and reform. Through insightful articles and engaging narratives, Samaj-Darpan 1.0 reflects the challenges faced by our community and the impactful interventions we have implemented.",
    // },
    // {
    //   img: "assets/img/m-samaj/samajDarpan2.0.png",
    //   title: "Samaj Darpan 2.0",
    //   link: "/darpan-view/2.0",
    //   description:
    //     "Samaj-Darpan 2.0, published by Mallabhum Prayas in August 2020, marks a significant evolution in our annual magazine series. This edition delves deeper into the pressing social issues that emerged during a challenging year, emphasizing resilience and community solidarity. Featuring compelling stories and case studies, Samaj-Darpan 2.0 highlights innovative solutions and grassroots initiatives that have made a tangible impact.",
    // },
    {
      img: "/assets/img/m-samaj/samajDarpan3.0.png",
      title: "Samaj Darpan 3.0",
      link: "/darpan-view/3.0",
      description:
        "The third edition of Samaj Darpan, the annual magazine of Mallabhum Prayas, marks yet another milestone in our shared journey of service, awareness, and empowerment. Aptly titled Samaj Darpan 3.0, this issue captures the evolving narrative of grassroots change, echoing the heartbeat of our community through stories, reflections, and vibrant expressions.",
    },
    {
      img: "/assets/img/m-samaj/samajDarpan4.0.png",
      title: "Samaj Darpan 4.0",
      link: "/darpan-view/4.0",
      description:
        "The fourth edition of Samaj Darpan marks a bold stride forward in documenting our collective spirit, struggles, and small victories. Samaj Darpan 4.0 continues to serve as the reflective voice of Mallabhum Prayas, showcasing not just what we've achieved, but how far we’re willing to go to build a just and compassionate society.",
    },
  ];

  const samagDarpan = (
    <div
      style={{
        fontSize: "16px",
        lineHeight: "1.5",
        color: "#333",
        margin: "20px 0",
      }}
    >
      <p>
        SamajDarpan is our annual magazine, thoughtfully crafted by our
        dedicated team to encapsulate the significant milestones and experiences
        of our organization over the past year. The name 'SamajDarpan' combines
        'Samaj,' meaning 'Society,' and 'Darpan,' meaning 'Mirror,' symbolizing
        our commitment to reflecting the realities of society and addressing its
        challenges.
      </p>
      <p>
        Each edition provides insights into the typical{" "}
        <b>
          societal landscape, showcases our interventions and initiatives,
          highlights the transformation of societal perceptions, and examines
          the impact of long-term reforms.
        </b>
        Released annually on our Foundation Day, SamajDarpan serves as a
        testament to our ongoing journey. We invite you to explore our work and
        support our mission as we strive for meaningful change in society. Thank
        you for being an integral part of our story.
      </p>
    </div>
  );
  return (
    <Portfolio
      portfolioHeader="ABOUT SAMAJ DARPAN"
      description={samagDarpan}
      portfolioImage={portfolioImage}
      fullImage={false}
      moreDetails
    />
  );
};

export default Darpan;
